import React from "react";
import { motion } from "framer-motion";
import "./Testimonials.css";

const data = [
  { text: "Dhanushdhari made finding our new apartment a breeze. The listings were accurate and the process was so much simpler than other sites. Highly recommend!", name: "Sarah L.", city: "Chicago, IL" },
  { text: "Amazing platform! I rented my dream house within a week. Customer support was very helpful.", name: "James M.", city: "Austin, TX" },
  { text: "Easy to use, secure payments, and verified properties. Saved us so much time searching online.", name: "Priya S.", city: "Mumbai, IN" },
];

const Testimonials = () => {
  return (
    <section className="testimonials container">
      <h2 className="section-title">What Our Members Say</h2>

      <div className="testimonial-container">
        {data.map((t, i) => (
          <motion.div
            className="testimonial"
            key={i}
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
          >
            <p className="quote">"{t.text}"</p>
            <h4>{t.name}</h4>
            <span className="city">{t.city}</span>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
